import { LeftNavPageLayout } from '@words-happen/ui-components';
import type React from 'react';

export const NotFoundPage: React.FC = () => {
  return (
    <LeftNavPageLayout>
      <nav>{/* left nav */}</nav>
      <header>{/* header */}</header>
      <main>
        {/* main */}
        Not found
      </main>
      <footer>{/* footer */}</footer>
    </LeftNavPageLayout>
  );
};
